import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client';
import { stringify } from 'hub-http/helpers/params';
import { AUTOMATION_PLATFORM_FLOW_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
export const FRAMEWORK_FOLDERS_FIELDNAME = 'automation_ui_management_frameworkFolders';
export const GET_ALL_FRAMEWORK_FOLDERS = registerQuery({
  fieldName: FRAMEWORK_FOLDERS_FIELDNAME,
  args: [],
  fetcher() {
    const queryString = stringify({
      enabledObjectTypeId: AUTOMATION_PLATFORM_FLOW_ID
    });
    return http.get(`framework/folders/v1?${queryString}`);
  }
});